import styled, { css } from 'styled-components';
import { min } from '../../../theme/breakpoints';

export const TooltipWrapper = styled.div`
  display: inline-flex;
  position: relative;
`;

interface ITooltipContentProps {
  alignHorizontal: 'left' | 'center' | 'right';
  alignVertical: 'top' | 'middle' | 'bottom';
  isVisible: boolean;
  backgroundColor?: string;
}

export const TooltipContent = styled.span<ITooltipContentProps>`
  font-family: ${({ theme }) => theme.fonts.primary.regular};
  width: 17.5rem;
  position: absolute;
  z-index: 2;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.tooltipBackground};
  color: ${({ theme }) => theme.colors.text};
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  border-radius: 2px;
  text-align: left;
  margin: 1rem 0;
  transition: 0.3s all ease-in-out;
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};

  a {
    font-size: 0.875rem;
  }

  ${({ alignVertical }) => {
    switch (alignVertical) {
      case 'top':
        return css`
          bottom: 100%;
        `;
      case 'middle':
        return css`
          top: 50%;
        `;
      default:
        return css`
          top: 100%;
        `;
    }
  }};

  ${({ alignHorizontal }) => {
    switch (alignHorizontal) {
      case 'left':
        return css`
          left: 0;
        `;
      case 'center':
        return css`
          left: 50%;
        `;
      default:
        return css`
          right: 0;
        `;
    }
  }};

  ${({ alignHorizontal, alignVertical }) => {
    if (alignHorizontal === 'center' && alignVertical === 'middle') {
      return css`
        transform: translate(-50%, -50%);
      `;
    } else if (alignHorizontal === 'center') {
      return css`
        transform: translate(-50%, 0);
      `;
    }
    return css``;
  }};

  &::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-width: 0 0.5rem 0.5rem 0.5rem;
    border-color: transparent transparent
      ${({ theme, backgroundColor }) => backgroundColor || theme.colors.tooltipBackground} transparent;
    border-style: solid;
    left: 50%;
    bottom: 100%;
    transform: translateX(-50%);
  }
`;

export const IconWrapper = styled.button`
  cursor: pointer;
  appearance: none;
  border: 0;
  padding: 0;
  background-color: transparent;
  display: inline-flex;
  transition: 0.2s all ease-in-out;

  @media screen and ${min('largeTablet')} {
    &:hover,
    &:focus {
      opacity: 0.5;
    }
  }
  svg {
    display: block;

    path {
      fill: ${({ theme }) => theme.colors.text};
    }
  }
`;
